import { BaseDevice, CustomLayout } from '../base_device'
import list_icon from '@/assets/img/device/tp87/list_icon.png'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import { getDeviceKeySquare } from './keysquare/keysquare'
import { tp87VKCodes } from './keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_IROKN_ST_V1 } from '../light/light_effect_list'

export class TP87 extends BaseDevice {
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_IROKN_ST_V1

  name: string = 'TP87'
  icon: string = list_icon
  width: number = 780

  square = getDeviceKeySquare(DevicePid.IYXTp87)
  fnDisableKeys: KK[] = [0, 84, 96, 85, 91, 97, 98, 92, 86, 90, 56, 62, 59, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78]
  vkcodes = tp87VKCodes

  inoperableKeys: KK[] = [0x3b]

  customLayout: CustomLayout = {
    0xc: this.createSquare(44.5, 2),
    0x24: this.createSquare(22.4, 2),
    0x3c: this.createSquare(22.4, 2),
    0x54: this.createSquare(4, 2),
    0x4f: this.createSquare(2, 2, 81, 40.5),
    0x55: this.createSquare(4, 2),
    0x2: this.createSquare(2, 2, 60.8, 40.5),
    0x50: this.createSquare(2, 2, 60.8, 40.5),
    0x56: this.createSquare(4, 2),
    0x3: this.createSquare(2, 2, 74.9, 40.5),
    0x51: this.createSquare(2, 2, 90, 40.5),
    0x4: this.createSquare(2, 2, 97.2, 40.5),
    0x52: this.createSquare(2, 2, 109.4, 40.5),
    0x5e: this.createSquare(46.6, 2),
    0x5: this.createSquare(2, 2, 52.6, 40.5),
    0xb: this.createSquare(2, 2, 52.6, 40.5),
    0x11: this.createSquare(2, 2, 52.6, 40.5),
    0x23: this.createSquare(2, 2, 252, 40.5),
    0x35: this.createSquare(2, 2, 52.6, 40.5),
    0x3b: this.createSquare(2, 2, 52.6, 40.5),
    0x41: this.createSquare(2, 2, 52.6, 40.5),
    0x53: this.createSquare(2, 2, 52.6, 40.5),
    0x59: this.createSquare(4, 2),
  }
}
